import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FuseContactScanService } from '../contact-scan.service';
import { MatSnackBar } from '@angular/material/snack-bar';

interface ContactData {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    mobileNumber: string,
    department: string,
    position: string
    [key: string]: any;
}

@Component({
    selector: 'contact-scan-dialog',
    templateUrl: './contact-scan.html',
    styleUrls: ['./contact-scan.scss']
})
export class ContactScanDialogComponent {
    @ViewChild('fileInput') fileInput: ElementRef;
    imagePreview: string;
    parsedData: ContactData;
    isLoading: boolean = false;
    maxFileSize = 1 * 1024 * 1024; // 5MB

    constructor(
        private _fuseContactScanService: FuseContactScanService,
        private _dialogRef: MatDialogRef<ContactScanDialogComponent>,
        private _snackBar: MatSnackBar
    ) { }

    get parsedDataEntries(): { key: string, value: any }[] {
        return this.parsedData ? Object.entries(this.parsedData).map(([key, value]) => ({ key, value })) : [];
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target as HTMLElement;
        target.classList.add('border-primary');
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target as HTMLElement;
        target.classList.remove('border-primary');
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target as HTMLElement;
        target.classList.remove('border-primary');

        const files = event.dataTransfer.files;
        if (files.length > 0) {
            this.handleFile(files[0]);
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files?.length > 0) {
            this.handleFile(input.files[0]);
        }
    }

    private handleFile(file: File): void {
        if (!file.type.startsWith('image/')) {
            this._snackBar.open('Please select a valid image file', 'Close', {
                duration: 3000,
                horizontalPosition: 'end',
            });
            return;
        }

        if (file.size > this.maxFileSize) {
            this._snackBar.open('File size should not exceed 5MB', 'Close', {
                duration: 3000,
                horizontalPosition: 'end',
            });
            return;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            this.imagePreview = e.target.result as string;
            this.isLoading = true;
            console.log("IS LOADING YAY: ", this.isLoading)

            try {
                this._fuseContactScanService.contactScanner(file).subscribe((res: ContactData) => {
                    this.parsedData = res;
                    this.isLoading = false;
                });
            } catch (error) {
                console.error('Error scanning contact:', error);
                this._snackBar.open('Failed to scan contact card. Please try again.', 'Close', {
                    duration: 3000,
                    horizontalPosition: 'end',
                });
                this.isLoading = false;
            }
        };

        reader.onerror = () => {
            this._snackBar.open('Error reading file. Please try again.', 'Close', {
                duration: 3000,
                horizontalPosition: 'end',
            });
            this.isLoading = false;
        };

        reader.readAsDataURL(file);
    }

    closeDialog(): void {
        this._dialogRef.close(this.parsedData);
    }
}